<template>
  <div id="contenedor-main-listado-convenio">
    <template
      v-if="!$vuetify.breakpoint.mobile">
      <desktop></desktop>
    </template>
    <template
      v-else>
      <desktop></desktop>
    </template>
  </div>
</template>

<script>
import Desktop from './Listado.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoConvenios',
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
